import React from "react";
import { Box } from "@mui/material";
import { useDroppable } from "@dnd-kit/core";
import colors from "../../../Constants/colors";
import { PredefinedSectionDocument } from "../../../Models/appendixStructure";

interface DraggablePredefinedSectionProps {
  doc: PredefinedSectionDocument;
  disabled?: boolean;
  children: React.ReactNode;
}

export const DraggablePredefinedSection: React.FC<
  DraggablePredefinedSectionProps
> = ({ doc, disabled, children }) => {
  const { setNodeRef: setDropRef, isOver } = useDroppable({
    id: `${doc.id}-predefined`,
    data: { id: doc.id },
    disabled,
  });

  return (
    <Box
      sx={{
        borderRadius: 2,
        transition: "background-color 0.2s, opacity 0.2s, border-color 0.2s",
        backgroundColor: isOver ? colors.orange50 : "transparent",
        border: isOver ? `2px solid ${colors.accent}` : `2px solid transparent`,
        opacity: disabled ? 0.6 : 1,
        cursor: "grab",
      }}
    >
      <Box ref={setDropRef}>{children}</Box>
    </Box>
  );
};
